import { render, staticRenderFns } from "./k-checkbox.vue?vue&type=template&id=f3d32bec&scoped=true"
import script from "./k-checkbox.vue?vue&type=script&lang=js"
export * from "./k-checkbox.vue?vue&type=script&lang=js"
import style0 from "./k-checkbox.vue?vue&type=style&index=0&id=f3d32bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d32bec",
  null
  
)

export default component.exports